import React, {useEffect, useState} from 'react';


import {Header} from '../../../components/Interface/Headers/Header';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';

import {
  Container,
  Content,
  TotalDebits,
  TotalDebitsTitle,
  TotalDebitsValue,
  Footer,
  Section,
  SectionScroll,
} from './styles';

import {Titles} from '../../../components/Interface/Typographies/Titles';
import {useHelpers} from '../../../context/helpers';
import {ReembolsoDTO} from '../../../dtos/ReembolsoDTO';

import {RootStackParamList} from '../../../dtos/RoutesDTO';
import {NativeStackScreenProps} from 'react-native-screens/lib/typescript/native-stack/types';
import {ReembolsoItem} from '../../../components/shared/Reembolsos/ReembolsoItem';
import {api} from '../../../services/api';
import {Loading} from '../../../components/Interface/Loadings/Loading';
import {useAuth} from '../../../context/auth';
import {NotFound} from '../../../components/Interface/Search/NotFound';
import { RFPercentage } from 'react-native-responsive-fontsize';
import { SafeAreaView } from 'react-native-safe-area-context';

type ScreenProps = NativeStackScreenProps<
  RootStackParamList,
  'SolicitaReembolso'
>;

export function SolicitaReembolso({navigation}: ScreenProps) {
  const {formatNumberToLocaleAmount} = useHelpers();
  const {isLogged} = useAuth();

  useEffect(() => {
    if (!isLogged) {
      navigation.navigate('Home');
    }
  }, [isLogged]);

  const [compras, setCompras] = useState([] as ReembolsoDTO[]);
  const [isLoading, setIsLoading] = useState(false);

  const [selectedDebit, setSelectedDebit] = useState<ReembolsoDTO>(
    {} as ReembolsoDTO,
  );

  const [totalDisponivelReembolso, setTotalDisponivelReembolso] = useState(0);

  useEffect(() => {
    async function fetchCompras() {
      try {
        setIsLoading(true);

        const response = await api.get('/solicitaCupomReembolso');

        let disponivelReembolso = 0;

        compras.forEach(item => {
          let itemValue = item.valorReembolso
            .replace('R$', '')
            .replace(' ', '')
            .replace(',', '.');
          disponivelReembolso += parseFloat(itemValue);
        });

        setTotalDisponivelReembolso(disponivelReembolso);
        setCompras(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }

    fetchCompras();
  }, []);

  function handleToggleDebits(item: ReembolsoDTO) {
    setSelectedDebit(item);
  }

  function handleSelectDebit() {
    navigation.navigate('ConfirmaReembolso', {item: selectedDebit});
  }

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : compras && compras.length > 0 ? (
        <SafeAreaView edges={['bottom']} style={{flex: 1}}>
        <Container>
          <Header icon="chevron-left" action={() => navigation.goBack()} />
          <Content>
            <Titles title="Escolha a compra que deseja reembolso" />

            <TotalDebits>
              <TotalDebitsTitle>
                Disponível para reembolso:{' '}
                <TotalDebitsValue>
                  {formatNumberToLocaleAmount(totalDisponivelReembolso)}
                </TotalDebitsValue>
              </TotalDebitsTitle>
            </TotalDebits>

            <SectionScroll showsVerticalScrollIndicator={false}>
              {compras && compras.length !== 0 && (
                <Section>
                  {compras.map((item, index) => (
                    <ReembolsoItem
                      key={index}
                      data={{
                        action: () => handleToggleDebits(item),
                        checked: selectedDebit.id === item.id,
                        index,
                        date: item.orderDate,
                        justificativaDesconto: item.justificativa_desconto,
                        formaPagamento: item.paymentMethod,
                        identificador: item.id,
                        installments: item.installment,
                        produto: item.produto,
                        quantidadeCupons: item.quantidadeCupons,
                        quantidadeCuponsUsados: item.quantidadeCuponsUsados,
                        valorTotal: item.totalValue,
                        valorReembolos: item.valorReembolso,
                      }}
                    />
                  ))}
                </Section>
              )}
            </SectionScroll>
          </Content>
          <Footer>
   
              <Button
                title="Continuar"
                onPress={handleSelectDebit}
                enabled={!!selectedDebit.id}
              />
        
          </Footer>
        </Container>
        </SafeAreaView>
      ) : (
        <>
           <Header icon="chevron-left" action={() => navigation.goBack()} />
          <NotFound title='Não existem compras elegíveis' text='Você não possui compras elegíveis para reembolso no momento.' style={{marginTop: -RFPercentage(5)}}/>
        </>
      )}
    </>
  );
}
